import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getDatosContractuales,
  getDatosDeContacto,
  getDatosGeneralesAfip,
  getDomicilioLegal,
  getDomicilioPostal,
} from "../../../redux/actions/informacion";
import CardContainer from "../../commons/cards/CardContainer";
import { StyledInformacionEmpresa } from './../../styled/Empresa';
import DatosDeContacto from "./cards/IndividualCards/formCards/DatosDeContacto";
import Domicilio from "./cards/IndividualCards/formCards/Domicilio";
import DatosEmpresaContractual from "./cards/IndividualCards/listCards/DatosEmpresaContractual";
import DatosGeneralesEnAfip from "./cards/IndividualCards/listCards/DatosGeneralesEnAfip";

const InformacionEmpresaContainer = () => {
  const dispatch = useDispatch();
  const informacionReducer = useSelector((state) => state.informacion);

  return (
    <Grid container spacing={2}>
      {/* Contenedor de la izquierda */}
      <StyledInformacionEmpresa.GridContainer item xs={6} >
        <CardContainer
          title="Datos Generales en AFIP"
          getData={() => dispatch(getDatosGeneralesAfip())}
          loading={informacionReducer.datosGeneralesAfip.loading}
          componente={
            <DatosGeneralesEnAfip
              data={informacionReducer.datosGeneralesAfip.data}
            />
          }
        />
        <CardContainer
          title="Datos Contractuales"
          getData={() => dispatch(getDatosContractuales())}
          loading={informacionReducer.datosContractuales.loading}
          componente={
            <DatosEmpresaContractual
              data={informacionReducer.datosContractuales.data}
            />
          }
        />
      </StyledInformacionEmpresa.GridContainer>
      {/* Contenedor de la derecha */}
      <StyledInformacionEmpresa.GridContainer item xs={6}>
        <CardContainer
          title="Domicilio Legal"
          getData={() => dispatch(getDomicilioLegal())}
          loading={informacionReducer.domicilioLegal.loading}
          componente={
            <Domicilio data={informacionReducer.domicilioLegal.data} />
          }
        />
        <CardContainer
          title="Domicilio Postal"
          getData={() => dispatch(getDomicilioPostal())}
          loading={informacionReducer.domicilioPostal.loading}
          componente={
            <Domicilio data={informacionReducer.domicilioPostal.data} />
          }
        />
        <CardContainer
          title="Datos de Contacto"
          getData={() => dispatch(getDatosDeContacto())}
          loading={
            informacionReducer.datosDeContacto.loading ||
            informacionReducer.postDatosContacto.loading
          }
          componente={
            <DatosDeContacto data={informacionReducer.datosDeContacto.data} />
          }
        />
      </StyledInformacionEmpresa.GridContainer>
    </Grid >
  );
};

export default InformacionEmpresaContainer;
